import App from '@/models/App'
import OrderingOrdererOrderItem from '@/models/OrderingOrdererOrderItem'

export default class OrderingOrdererOrderDeliveryItem extends App {
    static get entity() {
        return 'OrderingOrdererOrderDeliveryItems'
    }

    static all() {
        return this.query().with('orderingOrderItem').get()
    }

    static fields() {
        return {
            id: this.attr(''),
            orderingOrderDeliveryId: this.attr(''),
            orderingOrderItemId: this.attr(''),
            quantity: this.attr(0),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            orderingOrderItem: this.belongsTo(OrderingOrdererOrderItem, 'orderingOrderItemId'),
        }
    }

    static apiConfig = {
        actions: {
            update(orderingShipId, orderingOrderId, orderingOrderDeliveryId, orderingOrderDeliveryItemId, params) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/orders/${orderingOrderId}/deliveries/${orderingOrderDeliveryId}/items/${orderingOrderDeliveryItemId}`,
                    App.patch(params),
                    {
                        params: params,
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
